<template>
  <header class="py-8 shadow-lg bg-white sticky top-0 z-page-header">
    <div class="flex items-center">
      <div class="flex flex-3 flex-grow items-center justify-end">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="site-header__logo text-blue-900 h-20 w-84 cursor-pointer"
          @click="goToLoginPage"
        >
          <use
            :xlink:href="getIconPath('companion-logo')"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          />
        </svg>
      </div>
      <div class="flex flex-1 ms-2 items-center justify-end">
        <div class="flex me-22">
          <language-dropdown
            v-if="displayLanguageDropdown"
            id="site-header-language-dropdown"
            class="w-48"
            :value="language"
            @input="setLanguage"
            :display-base-locales-only="true"
          />
          <region-selection
            v-if="hasDifferentRegions"
            class="mx-2"
            :region="currentRegion"
            @click="onRegionSelect"
          />
        </div>
      </div>
    </div>

    <!-- Modals -->
    <region-selection-modal
      :show-modal="isRegionModalDisplayed"
      :region-data="regionData"
      :current-region="currentRegion"
      @cancel="onRegionChoiceCancel"
    />
  </header>
</template>

<script>
import RegionSelection from "@/components/login/RegionSelection.vue";
import LanguageDropdown from "@/components/ui/LanguageDropdown.vue";
import RegionSelectionModal from "@/components/login/RegionSelectionModal.vue";
import { mapActions, mapGetters } from "vuex";
import { getIconPath } from "@/utils/icon";

export default {
  components: {
    RegionSelectionModal,
    RegionSelection,
    LanguageDropdown,
  },
  props: {
    regionData: {
      types: Array,
      default: () => [],
    },
    displayLanguageDropdown: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      isRegionModalDisplayed: false,
      currentRegion: {},
    };
  },
  computed: {
    ...mapGetters("Language", ["language"]),
    hasDifferentRegions() {
      return this.regionData && this.regionData.length > 1;
    },
  },
  methods: {
    getIconPath: getIconPath,
    ...mapActions("Language", ["setLanguage"]),
    goToLoginPage() {
      this.$router.push({ path: "/login" }).catch(() => {});
    },
    onRegionSelect() {
      this.isRegionModalDisplayed = true;
    },
    onRegionChoiceCancel() {
      this.isRegionModalDisplayed = false;
    },
  },
  watch: {
    regionData() {
      if (this.hasDifferentRegions) {
        // Set the current region id depending on the current url
        this.currentRegion = this.regionData.find((e) =>
          window.location.href.includes(e.BaseURL)
        );
      } else {
        this.currentRegion = {};
      }
    },
  },
};
</script>
